module.exports = __webpack_public_path__ + "img/price-click-5.403a6a14.jpg";